import { motion } from "framer-motion";
import { Flower2, Clock, Heart } from "lucide-react";
import { useContent } from "@/context/ContentContext";

const VALUES = [
  {
    icon: Flower2,
    title: "Kualitas Florist Fresh",
    desc: "Hanya menggunakan seleksi bunga segar kualitas terbaik dari kebun lokal dan impor.",
  },
  {
    icon: Clock,
    title: "Presisi & Ketepatan Waktu",
    desc: "Proses pengerjaan disiplin dan rampung sebelum tamu pertama menginjakkan kaki.",
  },
  {
    icon: Heart,
    title: "Sentuhan Personal",
    desc: "Desain yang dikustomisasi khusus tanpa repetisi pasaran.",
  },
];

export const About = () => {
  const { content } = useContent();
  const a = content.about || {};
  const values = a.values && a.values.length ? a.values : VALUES;
  return (
    <section id="tentang" className="py-24 bg-[#F7F0E6]" data-testid="about-section">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 grid lg:grid-cols-2 gap-14 items-center">
        <motion.div
          initial={{ opacity: 0, x: -30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <p className="font-mono text-xs tracking-[0.3em] uppercase text-[#C5A059] mb-3">
            Tentang Kami
          </p>
          <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-medium text-[#1C1917] tracking-tight">
            {a.title || "Tentang Ascarya Dekorasi"}
          </h2>
          <p className="mt-5 text-[#4A443F] leading-relaxed">
            {a.story || "Berdiri sejak tahun 2019, Ascarya Dekorasi lahir dari gairah memadukan keindahan seni floristry dengan kemegahan arsitektur acara. Kami percaya setiap dekorasi harus menceritakan karakter dan perjalanan cinta unik dari pasangan."}
          </p>

          <div className="mt-8 space-y-5">
            {values.map((v, i) => {
              const Icon = (VALUES[i] || VALUES[0]).icon;
              return (
              <div key={i} className="flex gap-4">
                <div className="w-12 h-12 rounded-xl bg-white border border-[#E5D7C5] flex items-center justify-center shrink-0">
                  <Icon className="w-5 h-5 text-[#C5A059]" />
                </div>
                <div>
                  <h4 className="font-serif text-lg font-semibold text-[#1C1917]">
                    {v.title}
                  </h4>
                  <p className="text-sm text-[#786F66]">{v.desc}</p>
                </div>
              </div>
              );
            })}
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, x: 30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="relative"
        >
          <div className="rounded-3xl overflow-hidden shadow-[0_12px_30px_rgba(197,160,89,0.15)]">
            <img
              src={a.image || "https://images.unsplash.com/photo-1785339678169-9b19ecb4c443?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NjV8MHwxfHNlYXJjaHw0fHx3ZWRkaW5nJTIwdGFibGUlMjBkZWNvcmF0aW9uJTIwZmxvd2VycyUyMGx1eHVyeXxlbnwwfHx8fDE3OTA1NTYzNjR8MA&ixlib=rb-4.1.0&q=85"}
              alt="Studio Ascarya Dekorasi"
              className="w-full h-[520px] object-cover"
            />
          </div>
          <div className="absolute -bottom-6 -left-6 bg-white rounded-2xl border border-[#E5D7C5] p-6 shadow-lg hidden sm:block">
            <div className="font-serif text-4xl font-semibold text-[#C5A059]">{a.statValue || "350+"}</div>
            <div className="text-[11px] tracking-widest uppercase text-[#786F66]">
              {a.statLabel || "Momen Terdekorasi"}
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};
